import { render, staticRenderFns } from "./maindialog.vue?vue&type=template&id=499ac916&"
import script from "./maindialog.vue?vue&type=script&lang=js&"
export * from "./maindialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports